export default __webpack_public_path__ + "static/RaiseCapital-037f624361ca8ff339ec5ed20248075e.png";